import firebase from "firebase/app";
import "firebase/messaging";
import { store } from "@/store";
import $axios from "./axios-helper";
import { service_paths } from "@/constants/Services";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

let messaging;
if (firebaseConfig) {
  firebase.initializeApp(firebaseConfig);
  messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
}

function receiveMessage() {
  if (!messaging) return;
  return messaging.onMessage(payload => {
    store.commit("fcm/increaseNotifyTotal");
    store.commit("fcm/setNewNotification", payload);
    return payload;
  });
}
async function initFcm(userInfo) {
  const fcmToken = await getToken();
  if (!fcmToken || !userInfo) return;
  $axios
    .post(
      service_paths.device_tokens,
      {
        device_token: fcmToken,
        user_id: userInfo._id,
        type: "WEB"
      },
      undefined,
      undefined,
      undefined,
      false
    )
    .then(Response => {
      store.commit("fcm/setIdDevice", Response.data.id);
    });
}
function getToken() {
  if (!messaging) return;
  return messaging.getToken({
    vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY
  });
}

function removeDeviceToken() {
  const idDevice = store.getters["fcm/idDevice"];
  if (!idDevice) return;
  const path = `${service_paths.device_tokens}/${idDevice}`;
  $axios.delete(path);
  store.commit("fcm/clearNotifyTotal");
}

function checkNotificationPermisson(userInfo) {
  const idDevice = store.getters["fcm/idDevice"];
  if (Notification.permission === "granted" && !idDevice) {
    initFcm(userInfo);
  } else if (Notification.permission !== "granted" && idDevice) {
    removeDeviceToken();
  }
}

export {
  getToken,
  receiveMessage,
  initFcm,
  removeDeviceToken,
  checkNotificationPermisson
};
